import type { Query } from '@atlassian/react-resource-router';
import { createRouterSelector } from '@atlassian/react-resource-router/src/controllers/router-store';

// oxlint-disable-next-line typescript/no-invalid-void-type
export const useQuery: (args_0: void) => Query = createRouterSelector((state) => state.query);
